import { WEB } from "../../props";

export default function useCreationMeta(source) {
  return {
    platform: WEB,
    source,
  };
}
